import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';

function mapStateToProps({ progress }) {
  return { ...progress };
}

class Progress extends PureComponent {
  render() {
    const { progress } = this.props;

    return (
      <div className="spinner--container">
        <CircularProgress
          variant="determinate"
          value={progress}
          size={50}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, {})(Progress);

Progress.propTypes = {
  progress: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/containers/ProgressContainer.js